export enum AvailabilityType {
    openDate = "openDate",
    closedDate = "closedDate",
}
